module.exports = __webpack_public_path__ + "static/media/icon_instrument_drums.d40b5625.svg";